module.exports = __webpack_public_path__ + "img/searchicon.3fc63845.svg";